import APICall from './api-call';

class Sites {

    static async getMonthData(URL, requestOption) {
        try {
            // console.log("Sites URL :: ", URL, " >>>> ", requestOption);
            let response = await APICall.request(URL, requestOption);
            return response;
        } catch (error) {
            console.log('Exception while fetching Monthly data for Sites', error);
            return {
                message: []
            }
        }

    }

    static async getDayData(URL, requestOption) {
        try {
            let response = await APICall.request(URL, requestOption);
            return response;
        } catch (error) {
            console.log('Exception while fetching Day data for Sites', error);
            return {
                message: {}
            }
        }

    }

    static async getAuditData(URL, requestOption) {
        try {
            // console.log("getAuditData Sites URL :: ", URL, " >>>> ", requestOption);
            let response = await APICall.request(URL, requestOption);
            return response;
        } catch (error) {
            console.log('Exception while fetching Audit data for Sites', error);
            return {
                message: []
            }
        }

    }
}
export default Sites;